// 표준 상품 액션(rpc) — 단가표의 검수 요청·연결 제안 받기·연결 끊기·품목만 표시·우리 회사 브랜드.
import type { CatalogSubmitFields } from "@buildpy/core/modules/catalog/actions";

import { rpc } from "@/api/client";

export const getCatalogForm = () => rpc("catalog/actions/getCatalogForm");

export const submitCatalogProduct = (priceItemId: string, fields: CatalogSubmitFields) =>
  rpc("catalog/actions/submitCatalogProduct", priceItemId, fields);

export const acceptCatalogSuggestion = (priceItemId: string, productId: string) =>
  rpc("catalog/actions/acceptCatalogSuggestion", priceItemId, productId);

export const unlinkCatalogProduct = (priceItemId: string) => rpc("catalog/actions/unlinkCatalogProduct", priceItemId);

export const setCatalogOptOut = (priceItemId: string, value: boolean) => rpc("catalog/actions/setCatalogOptOut", priceItemId, value);

export const createOrgBrand = (name: string) => rpc("catalog/actions/createOrgBrand", name);
